import EnhancesPatrimony from "../components/ServiceDetail/contents/EnhancesPatrimony";
import FindProperty from "../components/ServiceDetail/contents/FindProperty";
import Marketing from "../components/ServiceDetail/contents/Marketing";
import RentProperty from "../components/ServiceDetail/contents/RentProperty";
import SellProperty from "../components/ServiceDetail/contents/SellProperty";
import Warranty from "../components/ServiceDetail/contents/Warranty";

interface ServiceDetail {
    slug: string;
    title: string;
    shortDesc: string;
    imagePath: string;
    content: React.ComponentType;
}

// I valori puntati (title e shortDesc ecc... ) sono chiavi di traduzione, quindi non contengono il testo direttamente, ma fanno riferimento a chiavi nel file di traduzione.

export const serviceDetailList: ServiceDetail[] = [
    {
        slug: "valorizza-patrimonio",
        title: "serviceDetailPage.valorizza-patrimonio.title",
        shortDesc: "serviceDetailPage.valorizza-patrimonio.shortDesc",
        imagePath: "/assets/images/services/valo-patrimonio.webp",
        content: EnhancesPatrimony
    },
    {
        slug: "vendita-immobili",
        title: "serviceDetailPage.vendita-immobili.title",
        shortDesc: "serviceDetailPage.vendita-immobili.shortDesc",
        imagePath: "/assets/images/services/vendita-immobiliare.webp",
        content: SellProperty
    },
    {
        slug: "ricerca-immobili",
        title: "serviceDetailPage.ricerca-immobili.title",
        shortDesc: "serviceDetailPage.ricerca-immobili.shortDesc",
        imagePath: "/assets/images/services/property-finding.webp",
        content: FindProperty
    },
    {
        slug: "affitti-locazioni",
        title: "serviceDetailPage.affitti-locazioni.title",
        shortDesc: "serviceDetailPage.affitti-locazioni.shortDesc",
        imagePath: "/assets/images/services/affitti.webp",
        content: RentProperty
    },
    {
        slug: "marketing",
        title: "serviceDetailPage.marketing.title",
        shortDesc: "serviceDetailPage.marketing.shortDesc",
        imagePath: "/assets/images/services/marketing.webp",
        content: Marketing
    },
    {
        slug: "garanzia-splendida",
        title: "serviceDetailPage.garanzia-splendida.title",
        shortDesc: "serviceDetailPage.garanzia-splendida.shortDesc",
        imagePath: "/assets/images/services/garanzia.webp",
        content: Warranty
    }
];      